import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import {token, domain} from '../Security';
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import loadingSpinner from './../../assets/loading.gif';
import { format } from 'date-fns';
//icons
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function TimeKeepingHoursWorkedReport({user, isHideSideMenu}) {
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payrollPeriodDescription, setPayrollPeriodDescription] = useState("");
    const [companyId, setCompanyId] = useState(0);
    const [company, setCompany] = useState(null);
    const [classificationId, setClassificationId] = useState(0);
    const [departmentId, setDepartmentId] = useState(0);
    const [locationId, setLocationId] = useState(0);
    const [errorState, setErrorState] = useState(false);
    const [loading, setLoading] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const numberWithCommasAndDecimal = (number) => {
        if(!number){
            return "0.00";
        }
        return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    function base64ToUint8Array(base64String) {
        const byteCharacters = atob(base64String); // Decode Base64
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        return new Uint8Array(byteNumbers);
    }
    const writeFont7Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 7, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }
    const writeFont8Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 8, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }

    const modifyAndDownloadPDF = useCallback(async (data) => {
        if (data.length <= 0) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No records found");
            return;
        }

        setLoading(true);
        console.log(data)

        try {
            // Load the existing PDF template
            const pdfUrl = `${window.location.origin}/docs/Time_Keeping_Hours_Worked_Report.pdf`;
            const response = await fetch(pdfUrl);
            const pdfBytes = await response.arrayBuffer();
            const pdfDoc = await PDFDocument.load(pdfBytes);
            const templatePdf = await PDFDocument.load(pdfBytes); // Load again for copying

            let page = pdfDoc.getPages()[0]; // Get first page
            const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

            let pageCount = 1;

            writeFont7Black({ page, font, x: 455, y: 20, text: `Page ${pageCount}` });

            //611 height

            const _dateToday = new Date().toISOString().split("T")[0];

            // Embed Company Logo
            if(company?.logo){
            const companyLogoBinary = base64ToUint8Array(company.logo);
            const companyLogo = await pdfDoc.embedPng(companyLogoBinary);
            page.drawImage(companyLogo, { x: 10, y: 500, width: 200, height: 100 });
            }
            
            writeFont8Black({ page, font, x: 650, y: 567, text: `${_dateToday}` });
            writeFont8Black({ page, font, x: 650, y: 545, text: `${user.employeePersonalInformationFullName}` });
            writeFont8Black({ page, font, x: 367, y: 453, text: `${payrollPeriodDescription}` });

            const startX_item_1 = 40;
            const startX_item_2 = 182;
            const startX_item_3 = 375;
            const startX_item_4 = 527;
            const startX_item_5 = 700;
            let startY = 389;
            const lineSpacing = 15;
            const minY = 50; // Prevents writing too low

            for (let index = 0; index < data.length; index++) {
                const item = data[index];

                if (startY - lineSpacing < minY) {
                    pageCount += 1;

                    const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
                    page = pdfDoc.addPage(templatePage);
                    startY = 389; // Reset Y position

                    // Embed Company Logo
                    if(company?.logo){
                    const companyLogoBinary = base64ToUint8Array(company.logo);
                    const companyLogo = await pdfDoc.embedPng(companyLogoBinary);
                    page.drawImage(companyLogo, { x: 10, y: 500, width: 200, height: 100 });
                    }
                    
                    writeFont8Black({ page, font, x: 650, y: 567, text: `${_dateToday}` });
                    writeFont8Black({ page, font, x: 650, y: 545, text: `${user.employeePersonalInformationFullName}` });
                    writeFont8Black({ page, font, x: 367, y: 453, text: `${payrollPeriodDescription}` });

                    writeFont7Black({ page, font, x: 455, y: 20, text: `Page ${pageCount}` });
                }

                let date = item.date ? item.date.split("T")[0] : "";
                const totalWorkedHours = item.otHours + item.hoursWorked;
            
                // Write employee data
                writeFont7Black({ page, font, x: startX_item_1, y: startY, text: `${item.employeePersonalInformationEmployeeId}` });
                writeFont7Black({ page, font, x: startX_item_2, y: startY, text: `${item.employeePersonalInformationFullName}` });
                writeFont7Black({ page, font, x: startX_item_3, y: startY, text: `${date}` });
                writeFont7Black({ page, font, x: startX_item_4, y: startY, text: `${item.locationDescription}` });
                writeFont7Black({ page, font, x: startX_item_5, y: startY, text: `${numberWithCommasAndDecimal(totalWorkedHours)}` });
            
                startY -= lineSpacing; // Move to next row
            }

            setShowRequestMessage(true);
            setIsSuccess(true);

            // Save and Download PDF
            const modifiedPdfBytes = await pdfDoc.save();
            const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });

            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = `Time_Keeping_Hours_Worked_Report.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(a.href);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error("Error:", error);
            setRequestMessage("Error processing PDF");
        }

        setLoading(false);
    }, [user, payrollPeriodDescription, company]);

    const fetchDataCompany = useCallback(async () => {
        const apiUrl =  domain + `/api/Company/${companyId}`;

        try {
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            return response.data;
        } catch (error) {
            return null
        }
    }, [companyId]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/time-keeping-hours-worked/payroll-period/${payrollPeriodId}/classification/${classificationId}/department/${departmentId}/location/${locationId}`;

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            const _company = await fetchDataCompany();
            setCompany(_company)

            modifyAndDownloadPDF(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [fetchDataCompany, modifyAndDownloadPDF, payrollPeriodId, classificationId, departmentId, locationId]);

    const generate = () =>{
        if(!payrollPeriodId
            || !company
        ){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        fetchData();
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo shadow-xl">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Time Keeping Hours Worked Report"}</span>
                            </div>
                            <h3>Generate Time Keeping Hours Worked Report</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row" style={{alignItems: "center", justifyContent: "normal"}}>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Payroll Period</div>
                                    <div className="info-item-input">
                                        <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} setPayrollPeriodDescription={setPayrollPeriodDescription}/>
                                    </div>
                                    <span style={{
                                                visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Company</div>
                                    <div className="info-item-input">
                                        <CompanyTypeSelect companyId={companyId} setCompanyId={setCompanyId} setCompany={setCompany}/>
                                    </div>
                                    <span style={{
                                                visibility: !companyId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Classification</div>
                                    <div className="info-item-input">
                                        <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId}/>
                                    </div>
                                    <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="info-item-holder row" style={{justifyContent: "normal"}}>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Department</div>
                                    <div className="info-item-input">
                                        <DepartmentIdSelect departmentId={departmentId} setDepartmentId={setDepartmentId}/>
                                    </div>
                                    <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Location</div>
                                    <div className="info-item-input">
                                        <LocationIdSelect locationId={locationId} setLocationId={setLocationId}/>
                                    </div>
                                    <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row">
                                <button id="activeEmployeesGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function PayrollPeriodIdSelect({payrollPeriodId, setPayrollPeriodId, setPayrollPeriodDescription}){
    const [isSelected, setIsSelected] = useState(false);
    
    const [payrollPeriodIds, setPayrollPeriodIds] = useState([]);

    const fetchData = async () => {
        //const currentYear = new Date().getFullYear();
        //const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setPayrollPeriodIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    function textFormatDate(dateStr) {
        const date = new Date(dateStr);
        const options = { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        };
        const formattedDate = date.toLocaleDateString("en-US", options);
        return formattedDate;
    }

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payrollPeriodId]);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
        const payrollPeriodSelected = payrollPeriodIds.find(payrollPeriod => payrollPeriod.id === parseInt(event.target.value));
        setPayrollPeriodDescription(`${textFormatDate(payrollPeriodSelected.dateFrom)} to ${textFormatDate(payrollPeriodSelected.dateTo)}`)
    };

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payrollPeriodId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose payroll period</option>
            {payrollPeriodIds.map((payrollPeriodId) => ( 
                SetPayrollPeriodId(payrollPeriodId)
            ))}
            </select>
        </div>
    );
};
function SetPayrollPeriodId(payrollPeriodId){
    const formattedDateFrom = format(payrollPeriodId.dateFrom, 'MM/dd/yyyy');
    const formattedDateTo = format(payrollPeriodId.dateTo, 'MM/dd/yyyy');

    return(
        <option value={payrollPeriodId.id}>{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription ? payrollPeriodId.payTypeDescription : ""}`}
        </option>
    )
}
function CompanyTypeSelect({companyId, setCompanyId, setCompany}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const selectedCompanyId = event.target.value; // Get the selected company ID
        setCompanyId(selectedCompanyId);
        const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

        if (selectedCompany) {
            setCompany(selectedCompany); // Set the full company object
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Company/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if (companyId !== "" && companyId !== 0 && companyId !== null && companyId !== undefined && companyId.length !== 0) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [companyId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={companyId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose company type</option>
            {data.map((companyId) => ( 
                SetCompanyType(companyId)
            ))}
            </select>
        </div>
    );
};
function SetCompanyType(company){
    return(
        <option value={company.id}>{
            company.name}
        </option>
    )

}
function ClassificationIdSelect({classificationId, setClassificationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function DepartmentIdSelect({departmentId, setDepartmentId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setDepartmentId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Department/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(departmentId !== "" && departmentId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [departmentId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={departmentId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose department</option>
            {data.map((departmentId) => ( 
                SetDepartmentId(departmentId)
            ))}
            </select>
        </div>
    );
};
function SetDepartmentId(departmentId){
    return(
        <option value={departmentId.id}>{
            departmentId.description}
        </option>
    )
}
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose location</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
export default TimeKeepingHoursWorkedReport
